export const CommonUserGroups = {
    AllUsers: '6',
    Administrations: '3',
};

export const RootId = 'aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa';
